// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3fQbteJd3oQu4il3LpMKkX.avcHn2VQJenBvoR5hilPG ._2ChX4GFAl1-UBiWknYZyEQ.smooch_button.web1on1_close,.avcHn2VQJenBvoR5hilPG ._2ChX4GFAl1-UBiWknYZyEQ.smooch_button.web1on1_close{bottom:0px;right:9px}\n", ""]);
// Exports
module.exports = exports;
